var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import { getColor } from "../../theme";
import margin from "../../mixins/margin";
import alignSelf from "../../mixins/alignSelf";
var SIZES = {
    small: "16px",
    medium: "24px",
    large: "40px",
};
var styledColor = function (_a) {
    var theme = _a.theme, color = _a.color;
    return color && "fill: ".concat(getColor(color)({ theme: theme }), ";");
};
var styledhoverColor = function (_a) {
    var theme = _a.theme, hoverColor = _a.hoverColor;
    return hoverColor && "&:hover { fill: ".concat(getColor(hoverColor)({ theme: theme }), "; }");
};
var styledRotate = function (_a) {
    var rotate = _a.rotate;
    return !isNaN(rotate) && "transform: rotate(".concat(rotate * 90, "deg);");
};
export var StyledIcon = styled.svg(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: ", ";\n  width: ", ";\n  opacity: ", ";\n  pointer-events: ", ";\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"], ["\n  height: ", ";\n  width: ", ";\n  opacity: ", ";\n  pointer-events: ", ";\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), function (_a) {
    var size = _a.size, height = _a.height;
    return height || SIZES[size];
}, function (_a) {
    var size = _a.size, width = _a.width;
    return width || SIZES[size];
}, function (_a) {
    var disabled = _a.disabled;
    return (disabled ? 0.3 : 1);
}, function (_a) {
    var disabled = _a.disabled;
    return (disabled ? "none" : "unset");
}, styledRotate, styledColor, styledhoverColor, margin, alignSelf);
var templateObject_1;
